import OptimizedLink from "../../../Atoms/OptimizedLink";
import { useCachedGql } from "../../../../hooks/useCachedGql";
import { getCityUrl } from "../../../../utils/getCityUrl";
import { Text } from "../../../Atoms/Typography";
import styles from "./FooterNavigation.module.css";

export default function FooterNavigation() {
  const {
    data,
    isLoading: loading,
    error,
  } = useCachedGql("getCitiesAndPrefecturesWithProducts", { mode: "server" });

  if (loading) {
    return <>loading</>;
  }

  if (error || !data || !data.locations) {
    return <>Could not load cities.</>;
  }

  return (
    <div className="AppLayout">
      <div className={styles.FooterNavigationContainer}>
        <div className={styles.FooterNavigationTitle}>
          <Text size="normal" bold>
            Tours in Japan & Thailand
          </Text>
        </div>
        <div>
          <ul className={styles.FooterNavigation}>
            {(data.locations.records || []).map(
              (location) =>
                location &&
                (location.translation && location.translation.name !== null ? (
                  <li key={location.id}>
                    <OptimizedLink
                      href={`/tours-${location.country.name.toLowerCase()}/${getCityUrl(
                        location,
                      )}?ref=footer_nav`}
                      className={styles.FooterNavigationItem}
                      prefetchMode="disable"
                    >
                      <span>{location.translation.name} tours</span>
                    </OptimizedLink>
                  </li>
                ) : null),
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}
